import { GetSoftphoneSettingsResponse } from '@weave/schema-gen-ts/dist/schemas/phone/softphones/softphones.pb';
import { useQueryClient } from 'react-query';
import { SoftphoneQueries } from '@frontend/api-softphone';

export const useSoftphoneUpdateCwiCache = (tenantId: string | undefined) => {
  const queryClient = useQueryClient();
  const queryKey = [tenantId, ...SoftphoneQueries.queryKeys.getCurrentUserSoftphone];

  const updateCwiSoftphoneCache = ({ deviceId, enabled }: { deviceId: string; enabled: boolean }) => {
    if (!deviceId) return;
    queryClient.cancelQueries(queryKey);

    const oldData = queryClient.getQueryData<GetSoftphoneSettingsResponse>(queryKey);
    const newData = {
      ...oldData,
      softphones: oldData?.softphones.map((phone) => {
        if (deviceId !== phone.id) return phone;
        return {
          ...phone,
          callWaitingIndicatorBeep: enabled,
        };
      }),
    };
    queryClient.setQueryData(queryKey, newData);

    return { oldData };
  };

  return { updateCwiSoftphoneCache, queryKey };
};
